import { createSlice } from "@reduxjs/toolkit";
import { ICompanySettings } from "../../shared/interfaces/setting/ISettings";

const initialState: ICompanySettings = {
  thumbnail: "",
  faviconPath: "",
  invertedThumbnail: "",
  primaryColor: localStorage.getItem("primaryColor") ?? "#431e5b",
  id: 0,
  title: "CRM - OneBMS",
  name: "",
  path: "",
  mime: "",
  originalName: "",
  createdAt: "",
  updatedAt: "",
};
const companySettingsSlice = createSlice({
  name: "companySettings",
  initialState,
  reducers: {
    setCompanySettings: (state, action) => {
      state = action.payload;
      return state;
    },
  },
});

export default companySettingsSlice;
